import axios from 'axios';
import { baseUrl } from '@/config';
import { forEach } from 'lodash';

export default {
  /**
   * [getWorkListForTable 작업내역 (목록) 리스트 가져오기]
   * @author {Yang}
   * @param  {[WorkParamVO]} params [searchParamList - 검색, selectedDate-선택된 날짜]
   * @return {[type]}        [description]
   */
  getWorkListForTable(params) {
    return axios.post(`${baseUrl}/work/get-work-list-for-table.do`, params);
  },
  /**
   * [getWorkListForCalendar 작업내역 (달력) 조회]
   * @author jeee12
   * @param  {Object} params [description]
   * @return {[type]}        [description]
   */
  getWorkListForCalendar(params) {
    return axios.post(`${baseUrl}/work/get-work-list-for-calendar.do`, params);
  },
  /**
   * 작업 추가 시 사용자 리스트 조회
   * @author kimjy
   * @return {[type]} [description]
   */
  getManagerList(params) {
    return axios.post(`${baseUrl}/work/get-manager-list.do`, params);
  },
  /**
   * [getWorkFilteringList 작업 내역 필터링 데이터를 출력한다. ]
   * @author {Yang}
   * @return {[type]} [description]
   */
  getWorkFilteringList(params) {
    return axios.post(`${baseUrl}/work/get-work-filtering-list.do`, params);
  },
  /**
   * [getWorkDetailsList 작업 상세내역 작업담당자, 대상장비리스트를 가져온다.]
   * @author {Yang}
   * @param  {[type]} params [workSeqNumber]
   */
  getWorkDetailsList(params) {
    return axios.post(`${baseUrl}/work/get-work-details-list.do`, params);
  },
  /**
   * 작업 추가
   * @author kimjy
   * @param  {Object} params workInfo, managerList, maintenanceList, workTarget, workTime
   */
  addWork(params) {
    return axios.post(`${baseUrl}/work/add-work.do`, params);
  },
  /**
   * [getWorkProcessHistList 작업처리등록 출력]
   * @author {Yang}
   */
  getWorkProcessHistList(params) {
    return axios.post(`${baseUrl}/work/get-work-process-hist-list.do`, params);
  },
  /**
   * [addWorkHist 작업상세보기 > 등록]
   * @author {Yang}
   */
  addWorkProcessHist(formParams) {
    return axios.post(`${baseUrl}/work/add-work-process-hist.do`, formParams);
  },
  /**
   * [exportWorkProcessHistFileDownload 작업상세보기 파일 다운로드]
   * @author {Yang}
   */
  exportWorkProcessHistFileDownload(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/work/export-work-process-hist-filedownload.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * [deleteWorkProcessHist 작업상세보기 작업 처리 삭제]
   * @author {Yang}
   */
  deleteWorkProcessHist(params) {
    return axios.post(`${baseUrl}/work/delete-work-process-hist.do`, params);
  },
  /**
   * [deleteWork 작업상세보기 - 작업삭제]
   * @author {Yang}
   */
  deleteWork(params) {
    return axios.post(`${baseUrl}/work/delete-work.do`, params);
  },
  /**
   * [getBasicInfoSubList 작업별 필터링 정보 가져오기]
   * @author {Yang}
   */
  getBasicInfoSubList() {
    return axios.get(`${baseUrl}/work/get-basicinfo-sub-list.do`);
  },
  /**
   * 작업 수정
   * @author jeee12
   * @param  {[type]} params 수정된 workInfo, managerList, maintenanceList, workTarget
   */
  updateWork(params) {
    return axios.post(`${baseUrl}/work/update-work.do`, params);
  },
  /**
   * (애플망고 시각화 도구 프로젝트) 타임라인 > 작업관리 > 팝업창에서 표현 시 필요한 작업관리 데이터 조회 (단일)
   * @author Song
   * @param  {[type]} params
   */
  getTargetWorkList(params) {
    return axios.post(`${baseUrl}/work/get-target-work-list.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/work/work.js